<div class="row mb-5 doc-vente-doc-form" style="margin-top:2%">
    <div class="col-12">
        <div class="row mb-3 align-items-end">
            <div class="col-lg-4 col-md-6 mb-3 mb-md-0">
                <label class="d-block mb-1" for="labelBonLivraison">Label</label>
                <input
                    id="labelBonLivraison"
                    type="text"
                    class="form-control"
                    name="labelBonLivraison"
                    [(ngModel)]="labelText"
                    [placeholder]="documentTypeLabel"
                />
            </div>
            <div class="col-lg-4 col-md-6">
                <label class="d-block mb-1" for="couleurBonLivraison">Couleur du document</label>
                <div class="doc-vente-color-wrap">
                    <span class="doc-vente-color-value">{{ couleurText }}</span>
                    <input
                        id="couleurBonLivraison"
                        type="color"
                        class="doc-vente-color-input"
                        name="couleurBonLivraison"
                        [(ngModel)]="couleurText"
                        title="Choisir une couleur"
                    />
                </div>
            </div>
        </div>

        <div class="mb-2">
            <div class="custom-control custom-checkbox">
                <input class="custom-control-input" type="checkbox" id="blContactCheckbox" name="blMt" [(ngModel)]="affMontantTotaux">
                <label class="custom-control-label" for="blContactCheckbox">
                    Afficher les montants totaux
                </label>
            </div>
        </div>

        <div class="mb-2">
            <div class="custom-control custom-checkbox">
                <input class="custom-control-input" type="checkbox" id="blContact" name="blContact" [(ngModel)]="affInfContact">
                <label class="custom-control-label" for="blContact">
                    Afficher les informations de contact
                </label>
            </div>
        </div>

        <div class="mb-2">
            <div class="custom-control custom-checkbox">
                <input class="custom-control-input" type="checkbox" id="blDesc" name="blDesc" [(ngModel)]="affCourteDesp">
                <label class="custom-control-label" for="blDesc">
                    Afficher une courte description
                </label>
            </div>
        </div>
        <div class="mb-2">
            <div class="custom-control custom-checkbox">
                <input class="custom-control-input" type="checkbox" id="blInfo" name="blInfo" [(ngModel)]="affInfos">
                <label class="custom-control-label" for="blInfo">
                    Afficher les informations
                </label>
            </div>
        </div>

        <div class="mb-1"><hr class="m-0 divis"></div>

        <div class="mb-2">
            <label class="form-check-label label-large d-block mb-2" for="noteBonLivraison">
                Note
            </label>
            <textarea id="noteBonLivraison" class="form-control note" name="noteBonLivraison" [(ngModel)]="noteText" placeholder="Saisissez une note" rows="4"></textarea>
        </div>
    </div>
</div>

<div class="d-flex justify-content-end align-items-center flex-wrap w-100 position-fixed-bottom mt-2 mb-2">
    <a class="btn btn-grey waves-effect m-1" routerLink="/main/parametre/document">Annuler</a>
    <button type="button" class="btn btn-green waves-effect m-1" (click)="appercue()">Aperçu de la configuration</button>
    <button type="button" class="btn btn-primary waves-effect m-1" (click)="saveParametreDocument()" [disabled]="saving">{{ saving ? 'Enregistrement…' : 'Enregistrer' }}</button>
</div>
